import { render, staticRenderFns } from "./AccountLocked.vue?vue&type=template&id=3c87c058&"
import script from "./AccountLocked.vue?vue&type=script&lang=ts&"
export * from "./AccountLocked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports